/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {RoleFormComponent as ɵc} from './role-form/role-form.component';
export {RoleComponent as ɵb} from './role.component';
export {declaration as ɵa} from './role.module';
export {RoleRoutes as ɵd} from './role.routing';